import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import api from '../api';

export async function getLoyaltyProgramsByCompany(companyId) {
  try {
    if (!companyId || !['string', 'number'].includes(typeof companyId)) {
      throw new Error('invalid company id');
    }

    const { data } = await api.get(`/loyalty/program/empresa/${companyId}/historico`);
    if (!Array.isArray(data)) {
      throw new Error('invalid data');
    }

    return new Success(data);
  } catch (error) {
    console.log(error);
    return new Failure();
  }
}
